import 'howler';
import 'gsap';

export {default as Omy} from './omy/Omy';
export {default as OmyGame} from './omy/OmyGame';
export {OMY_SETTING, OmyConst} from './omy/OmyConst';
export {default as OContainer} from "./omy/display/OContainer";
export {default as OParticle} from "./omy/display/particles/OParticle";
export {default as OParticleContainer} from "./omy/display/particles/OParticleContainer";
export {default as OSprite} from "./omy/display/sprites/OSprite";
export {default as OActor} from "./omy/display/actors/OActor";
export {default as OActorSpine} from "./omy/display/actors/OActorSpine";
export {default as OTextBitmap} from "./omy/display/texts/OTextBitmap";
export {default as OTextFont} from "./omy/display/texts/OTextFont";
export {default as OTextNumberBitmap} from "./omy/display/texts/OTextNumberBitmap";
export {default as OTextNumberFont} from "./omy/display/texts/OTextNumberFont";
export {default as OMultiStyleTextFont} from "./omy/display/texts/OMultiStyleTextFont";
export {default as OMultiStyleTextNumberFont} from "./omy/display/texts/OMultiStyleTextNumberFont";
export {default as OTextInput} from "./omy/display/texts/OTextInput";
export {default as OGraphic} from "./omy/display/OGraphic";
export {default as OMath} from "./omy/utils/OMath";
export {default as OButton} from "./omy/display/buttons/OButton";
export {default as OButtonMod} from "./omy/display/buttons/OButtonMod";
export {default as OButtonTween} from "./omy/display/buttons/OButtonTween";
export {default as OCheckBoxTween} from "./omy/display/buttons/OCheckBoxTween";
export {default as OCheckBox} from "./omy/display/buttons/OCheckBox";
export {default as OSlider} from "./omy/display/OSlider";
export {default as OSound} from "./omy/managers/OSound";
export {Key} from "./lib/pixi.js-keyboard/Key";
export {default as StringUtils} from "./omy/utils/StringUtils";
export {default as ORevoltParticleSequence} from './omy/display/particles/ORevoltParticleSequence';
export {default as ORevoltParticleEmitter} from './omy/display/particles/ORevoltParticleEmitter';
export {default as SimpleCache} from './omy/utils/SimpleCache';

if (typeof window !== 'undefined') {
    window.PIXI = PIXI;
} else if (typeof global !== 'undefined') { // Add to global in Node.js (for testing, etc).
    global.PIXI = PIXI;
}

document.oncontextmenu = document.body.oncontextmenu = function () {
    return false;
};
